<template>
  <v-textarea solo :value="content" :id="id" ref="inputField" @input="updateValue" :rows="rowsValue" no-resize :style="style" outlined/>
</template>

<script>
import uuid from 'uuid/v4'
import Scrollable from './Scrollable'

export default {
  name: 'TextAreaField',
  components: { Scrollable },
  props: {
    value: {},
    rows: {},
    maxWidth: {}
  },
  data () {
    return {
      id: uuid(),
      content: null,
      rowsValue: 5
    }
  },
  created: function () {
    this.content = this.value
    if (this.rows) {
      this.rowsValue = this.rows
    }
  },
  computed: {
    style: function () {
      let style = ''
      if (this.maxWidth) {
        style += 'max-width:' + this.maxWidth + 'px;'
      }
      return style
    }
  },
  methods: {
    updateValue: function (val) {
      this.content = val
      this.$emit('input', this.content)
    },
    focus: function () {
      this.$nextTick(() => this.$refs.inputField.focus())
    }
  },
  watch: {
    value (val) {
      this.content = val
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TextAreaField.vue